module.exports = __webpack_public_path__ + "static/pie_painter_3-0e0f219d36b31d9eebdd76aeb6a7963a.png";